<template>
    <div id="goodList">
        <Breadcrumb></Breadcrumb>
        <div style="background-color: #FFFFFF;margin-top: 10px;border: 1px solid #ccc">
            <el-form ref="form" :model="form" label-width="80px" class="goods-list-search-form">
                    <el-form-item label="仓库位置 : ">
                        <el-select clearable  v-model="form.wareId" placeholder="请选择" style="width: 400px" size="small" @change="loadData">
                            <el-option v-for="item in repositoryList" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                <el-form-item label="搜索类型 : ">
                    <el-radio-group v-model="form.type" size="medium" class="hide_input" @change="searchTypeChange">
                        <el-radio label="0">商品SKU</el-radio>
                        <el-radio label="1">商品编码</el-radio>
                        <el-radio label="2">商品名称</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="搜索内容 : ">
                    <el-input v-model.trim="form.content" :placeholder="placeholderContent"
                              style="width: 329px" size="small" onkeyup="this.value=this.value.replace(/，/ig,',')"></el-input>
                    <el-button type="primary" @click="loadData" style="margin-left: 15px" size="small">搜索</el-button>
                </el-form-item>
                <el-form-item label="商品分类 : " prop="typeId">
                    <TreeSelect :props="treeSelect" :options="treeData"  v-model="form.typeId" ref="childSelTree"
                                style="width: 400px"  @getValue="getTreeNodeId"></TreeSelect>
                </el-form-item>
                <el-form-item label="排序类型 : ">
                    <el-radio-group v-model="form.sort" size="medium" class="hide_input sort-group">
                        <el-radio label="CREATE_TIME">按创建时间<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                        <el-radio label="UPDATE_TIME">按更新时间<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                        <el-radio label="WARE_NUM">按库存总量<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                        <el-radio label="COMM_PRICE">按单价<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                        <el-radio label="COMM_SKU">按SKU<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                    </el-radio-group>
                </el-form-item>
                </el-form>
        </div>
        <!-- 表格操作栏 -->
        <div style="margin-top: 15px">
            <el-row type="flex">
<!--                <el-col :span="8" style="font-size: 13px;color: #39a55a;margin: auto">库存总价值:{{money}}；库存总数：{{size}}</el-col>-->
                <el-col :span="8" style="margin: auto">
                    <span style="color: #A2A2A2">已选择条数：{{multipleSelection.length}}</span>
                </el-col>
                <el-col :span="8" style="text-align: right;">
                    <el-dropdown placement="bottom-start"  @command="handleCommand">
                        <el-button type="primary" size="small" style="margin-right: 2px">
                            批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="delete">批量删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown placement="bottom-start" @command="moveToStore">
                        <el-button type="primary" size="small" :disabled="multipleSelection.length == 0">
                            添加商品至<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="item in repositoryList" :command="item.value">{{item.label}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="primary" @click="importDialogVisible = true" style="margin-left:2px" size="small">导入</el-button>
                    <el-button style="margin-left:2px" type="primary" @click="exportDialogVisible = true" size="small">导出</el-button>
                </el-col>
            </el-row>
        </div>
        <!-- 商品表格 -->
        <div>
            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;"
                      @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="img" label="商品信息" width="350px" align="center">
                    <template slot-scope="scope">
                        <el-col :span="7">
                            <el-popover placement="right" width="300" trigger="hover" :disabled="scope.row.picUrl == null">
                                <img  class="img-big" :src="scope.row.picUrl" style="width: 300px;height: 300px"/>
                                <img v-if="scope.row.picUrl != null" slot="reference" class="img-small" :src="scope.row.picUrl" style="width: 70px;height: 70px;padding: 1px;border: 1px solid #EBEEF5"/>
                                <img v-else slot="reference" class="img-small" src="../../../assets/images/kong.png" style="width: 70px;height: 70px;padding: 1px;border: 1px solid #EBEEF5"/>
                            </el-popover>
                        </el-col>
                        <el-col :span="7" style="margin-left: 5px;font-size: 13px">
                            <div style="width: 250px;text-align: left;margin-left: 5px">商品SKU:{{scope.row.commSku}}</div>
                            <div style="width: 250px;text-align: left;margin-left: 5px">中文名称:{{scope.row.chinName}}</div>
                            <div style="width: 250px;text-align: left;margin-left: 5px">商品编码:{{scope.row.commId}}</div>
                            <div style="width: 250px;text-align: left;margin-left: 5px">备注:{{scope.row.remarks}}</div>
                        </el-col>
                    </template>
                </el-table-column>
                <el-table-column prop="wareNum" label="库存信息" width="150" align="center">
                </el-table-column>
                <el-table-column prop="commPrice" label="单价(CNY)" width="150" align="center">
                </el-table-column>
                <el-table-column label="总价" align="center" :formatter="totalPriceFarmat">
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center">
                    <template slot-scope="scope">
                        <span>{{parseTime(scope.row.createTime,'{y}-{m}-{d} {h}:{i}')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="更新时间" align="center">
                    <template slot-scope="scope">
                        <span>{{parseTime(scope.row.updateTime,'{y}-{m}-{d} {h}:{i}')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="handel" label="操作" align="center">
                    <template slot-scope="scope">
                        <div><el-button type="text" size="mini" @click="updateRow(scope.row)">更新</el-button></div>
                        <div><el-button type="text" size="mini" @click="editNote(scope.row,scope.$index)">备注</el-button></div>
                        <div><el-button type="text" size="mini" @click="removeRow(scope.row,scope.$index)">删除</el-button></div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination background style="float: right;" @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.currentPage" :page-sizes="[10, 50, 100, 400]" :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
        <!-- 导入弹出框 -->
        <el-dialog :close-on-click-modal="false"   title="导入商品" id="import" :visible.sync="importDialogVisible" width="30%">
            <!-- 上传控件 -->
            <el-upload class="upload-demo" ref="upload" action="https://jsonplaceholder.typicode.com/posts/"
                       :on-preview="handlePreview"
                       :on-remove="handleRemove" :file-list="importExcelFileList" :auto-upload="false">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <el-link type="primary" style="margin-left: 20px;">下载模版</el-link>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                					<el-row>
                						<el-col :span="12">
                							<div style="text-align: left;">
                								<span><font
                                                        style="font-size: 14px;color: red;">注：一次最多导入5000行数据</font></span>
                							</div>
                						</el-col>
                						<el-col :span="12">
                							<el-button @click="importDialogVisible = false" size="mini">取 消</el-button>
                							<el-button type="primary" @click="submitUpload" size="mini">确 定</el-button>
                						</el-col>
                					</el-row>
                				</span>
        </el-dialog>
        <!-- 导出弹出框 -->
        <el-dialog :close-on-click-modal="false"   title="导出清单" id="export" :visible.sync="exportDialogVisible" width="30%">
            <span>已导出:<font style="color: red">XX</font></span><br>
            <span>导出文件已生成，请立即下载！</span><br>
            <div>
                <el-progress :text-inside="true" :stroke-width="24" :percentage="100" status="success"></el-progress>
            </div>
            <span slot="footer" class="dialog-footer">
                					<el-button @click="exportDialogVisible = false">取 消</el-button>
                					<el-button type="primary" @click="dialogVisible = false">下 载</el-button>
                				</span>
        </el-dialog>
        <!-- 备注弹出框 -->
        <el-dialog :close-on-click-modal="false"   title="添加备注" :visible.sync="dialogFormVisible">
            <el-form :model="noteForm">
            <el-row type="flex" :gutter="20" style="margin-top: 10px">
                <el-col :span="4" style="text-align: right">
                    <span style="font-size: 14px">内容:</span>
                </el-col>
                <el-col :span="18">
                    <el-input type="textarea" placeholder="请输入内容" v-model="noteForm.remark" maxlength="500" show-word-limit
                              :autosize="{ minRows: 8, maxRows: 10}"></el-input>
                </el-col>
            </el-row>
        </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="submitEditNode">提 交</el-button>
            </div>
        </el-dialog>
        <!-- 更新弹出框 -->
        <el-dialog :close-on-click-modal="false"   class="store-manage-update-dialog" title="更新" :visible.sync="dialogUpdateFormVisible" width="600px">
            <div style="position: relative">
                <el-form :model="updateForm" label-width="120" style="margin: 20px 10px 10px">
                    <div style="width: 100px;height: 100px;position: absolute;top: 10px;right: 17px;box-shadow: 0 8px 13px 0 rgba(0, 0, 0, 0.3)">
                        <img v-if="updateForm.picUrl != null" :src="updateForm.picUrl" style="width: 100%;height: 100%;border: 1px solid #ccc">
                        <img v-else src="../../../assets/images/kong.png" style="width: 100%;height: 100%;border: 1px solid #ccc"/>
                    </div>
                    <el-form-item label="商品SKU: ">
                        <a href="javascript:void(0)" @click="goToGoodsManage(updateForm.commId)" style="text-decoration: none;color: #409eff">{{updateForm.commSku}}</a>
                    </el-form-item>
                    <el-form-item label="所属仓库: ">
                        <span>{{updateForm.wareName}}</span>
                    </el-form-item>
                    <el-form-item label="商品单价: ">
                        <el-input style="width: 50%" size="small" v-model="updateForm.commPrice" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="库存信息: ">
                        <el-input style="width: 50%" size="small" v-model="updateForm.wareNum" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="备注: ">
                        <el-input type="textarea" v-model="updateForm.remark"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="dialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {getGoodsList,updateRemark,deleteByCommIds,moveToStore} from "@/api/store/storeManage";
    import TreeSelect from '@/components/common/treeSelect';
    export default {
        name:'goodsList',
        components:{Breadcrumb,TreeSelect},
        data: function () {
            return {
                total: 0,
                //下拉树
                treeSelect: {
                    value: 'id',
                    label: 'name',
                    children: 'children',
                },
                money: '15.00 元',
                size: '5',
                pageSize: '0 条',
                form: {
                    wareId:null,//仓库位置
                    type: '0',
                    content: '',
                    typeId:null,//商品分类
                    sort: 'CREATE_TIME',
                    byAsc:'desc',//升序或者降序
                    currentPage: 1,
                    pageSize: 10
                },
                currentPage: 1,
                tableData: [],
                //导出
                exportDialogVisible: false,
                //导入
                importDialogVisible: false,
                importExcelFileList: [],
                // 备注框
                dialogFormVisible: false,
                formLabelWidth: '45px',
                noteForm:{
                    currentRow:null,
                    remark:null,
                    index:null,
                },
                placeholderContent:'多个sku间隔用逗号隔开',
                //更新表单
                updateForm: {
                    commId:null,
                    picUrl:null,
                    commSku:null,
                    wareName:null,//所属仓库
                    commPrice:null,//商品单价
                    wareNum:null,//库存
                    remark:null,//备注

                },
                // 更新的表单显示状态
                dialogUpdateFormVisible: false,
                // 更新的表单长度
                updateFormLabelWidth: '120px',
                multipleSelection:[],//表格选中的行

            };
        },
        computed:{
            treeData(){
                return this.$store.state.repository.treeSelectData;
            },
            repositoryList(){
                return this.$store.state.repository.repositoryList;
            }
        },
        created(){
            this.loadData();
        },
        methods: {
            //加载表格数据
            loadData(){
                getGoodsList(this.form).then(res =>{
                    this.total = res.total;
                    this.tableData = res.rows;
                })
            },
            turnWay(e){
                var classVal =  e.target.className;
                if(classVal == 'el-icon-caret-top'){
                    e.target.setAttribute('class','el-icon-caret-bottom');
                    this.form.byAsc = 'desc';
                }else{
                    e.target.setAttribute('class','el-icon-caret-top');
                    this.form.byAsc = 'asc';
                }
                this.loadData();
            },
            //获取本平台树的ID
            getTreeNodeId(val){
                this.form.typeId=val;
            },
            searchTypeChange(val){
                if(val == '0'){
                    this.placeholderContent = '多个sku间用逗号隔开';
                }else if(val == '1'){
                    this.placeholderContent = '多个商品编码用逗号隔开';
                }else{
                    this.placeholderContent = null;
                }

            },
            moveToStore(val){
                let commIds = [];
                this.multipleSelection.forEach(row => {
                    commIds.push(row.commId);
                });
                moveToStore({'commIds':commIds,'wareId':val}).then(res =>{
                    if(res.code == 200){
                        this.$message.success("操作成功");
                        this.loadData();
                    }
                }).catch();

            },
            handleSelectionChange(val) {
               this.multipleSelection = val;
            },
            handleCommand(command){
                if(command == 'delete'){
                    let num = this.multipleSelection.length;
                    if(num == 0){
                        this.$message.warning("请选择要删除的商品！");
                        return false;
                    }
                    this.$confirm('确定要删除选中的 '+ num +' 个商品吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let ids = [];
                        this.multipleSelection.forEach(row =>{
                            ids.push(row.commId);
                        });
                        deleteByCommIds(ids).then(res =>{
                            if(res.code == 200){
                                this.$message.success("删除成功");
                                this.loadData();
                            }else{
                                this.$message.error("删除失败");
                            }
                        });
                    }).catch(() => {});
                }
            },
            // 分页控制
            handleSizeChange: function (val) {
                this.form.pageSize = val;
                this.loadData();
            },
            handleCurrentChange(val) {
                this.form.currentPage = val;
                this.loadData();
            },
            totalPriceFarmat(row){
                if(row.commPrice == null || row.wareNum == null){
                    return null
                }else{
                    return Math.floor(parseFloat(row.commPrice*100 * row.wareNum))/100;
                }
            },
            //更新
            updateRow(row) {
                console.log(row);
                // 更新表单显示状态
                this.dialogUpdateFormVisible = true;
                this.updateForm.commId = row.commId;
                this.updateForm.picUrl = row.picUrl;
                this.updateForm.commSku = row.commSku;
                this.updateForm.commPrice = row.commPrice;
                this.updateForm.wareNum = row.wareNum;
                this.updateForm.remark = row.remarks;
            },
            goToGoodsManage(id){
                alert(id);
            },
            editNote(row,index){
                this.dialogFormVisible = true;
                this.noteForm.remark = row.remarks;
                this.noteForm.currentRow = row;
                this.noteForm.index = index;
            },
            submitEditNode(){
                this.dialogFormVisible = false;
                this.noteForm.currentRow.remarks = this.noteForm.remark;
                let params = {'remark':this.noteForm.remark,'commId':this.noteForm.currentRow.commId}
                updateRemark(params).then(res =>{
                    if(res.code == 200){
                        this.$set(this.tableData,this.noteForm.index,this.noteForm.currentRow);
                        this.$message.success("操作成功！")
                    }else{
                        this.$message.error("操作失败");
                    }
                });
            },
            //删除行
            removeRow(row,index){
                this.$confirm('确定要删除商品「'+row.chinName + '」吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = [];
                    ids.push(row.commId);
                    deleteByCommIds(ids).then(res =>{
                        if(res.code == 200){
                            this.$message.success("删除成功");
                        }else{
                            this.$message.error("删除失败");
                        }
                    });
                }).catch(() => {});
            },
            //导入上传控制
            submitUpload() {
                this.$refs.upload.submit();
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            }
        }
    }
</script>
<style scoped>
    #goodList{width: 100%}
    #import .el-dialog__header {
        background-color: #EEEEEE;
    }

    #export .el-dialog__header {
        background-color: #EEEEEE;
    }
</style>
